module.exports = __webpack_public_path__ + "media/images/prediction/special/condor/img_logo_publisher-a9e0f8a8e851a6e47370e741991c82f1.jpg";